<!--
 * @Author: 仙道
 * @Date: 2022-08-23 21:22:36
 * @LastEditTime: 2022-10-27 18:31:05
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/fusion/FusionDrawer.vue
-->
 
<template>
  <a-drawer
    :closable="false"
    :title="title"
    :visible="visible"
    :width="width"
    @close="close"
    destroyOnClose
    placement="right"
  >
    <a-button @click="back" class="ml-12px" type="primary" v-if="drillingCount>1">返回</a-button>
    <DetailIndex :is="fusionView" :query="fusionQuery" v-if="visible" />
  </a-drawer>
</template>

<script>
  import DetailIndex from './DetailIndex.vue'

  export default {
    name: 'FusionModalDrawer',
    components: {
      DetailIndex
    },

    data () {
      return {
        title: '',
        width: 1040,
        visible: false,
        disableSubmit: false,
        viewPath: {
          'FusionDevice': 'equipment/account/modules/DeviceDetail',
          'FusionManufacturers': 'fusion/components/Manufacturers',
          'FusionProcess': 'fusion/components/Process',
          'FusionPerson': 'fusion/components/Person'
        },
        fusionView: '',
        fusionQuery: {},
        drillingCount: 0,
        stashPre: {},
        stashDrillingList: []
      }
    },
    methods: {
      show (view = '', query = {}) {
        this.visible = true

        this.fusionQuery = { ...query }
        // if (this.drillingCount > 0) {
        //   this.stashPre = { query, view }
        // }
        const stashDrillingList = this.$Jlodash.clone(this.stashDrillingList)
        stashDrillingList.push({
          query, view
        })
        this.stashDrillingList = stashDrillingList
        this.drillingCount++
        this.fusionView = (resolve) => require([`@/views/${this.viewPath[view]}.vue`], resolve)
      },

      close () {
        // this.$emit('ok');
        this.drillingCount = 0
        this.stashDrillingList = []
        this.visible = false;
      },
      handleOk () {
        // this.$refs.detailPage.submitForm();
      },
      submitCallback (id = '') {
        this.$emit('ok', id);
        this.visible = false;
      },
      handleCancel () {
        this.close()
      },
      back () {
        this.visible = false
        this.drillingCount--
        const stashList = this.$Jlodash.clone(this.stashDrillingList)
        stashList.splice(this.drillingCount, 1)
        this.stashDrillingList = stashList

        const { query, view = '' } = stashList[stashList.length - 1]
        this.fusionQuery = { ...query }
        this.fusionView = (resolve) => require([`@/views/${this.viewPath[view]}.vue`], resolve)
        this.visible = true
      }
    }
  }
</script>